export const NonEssentialVendors = {
  Wootric: 'Wootric',
  FeedbackCollector: 'Feature Feedback Collector',
} as const;

export type NonEssentialVendors =
  (typeof NonEssentialVendors)[keyof typeof NonEssentialVendors];

export type CookieConsentResult = Record<NonEssentialVendors, boolean>;
